import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import Toasted from 'vue-toasted'; 
import UserMessagePlugin from './plugins/UserMessagePlugin.js';
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import AssetPlugin from './plugins/AssetPlugin.js';
import store from './store/index';
import axios from 'axios';

Vue.config.productionTip = false

Vue.use(AssetPlugin);
Vue.use(Toasted);
Vue.use(UserMessagePlugin);

// Register a global-error-notification toast.
Vue.toasted.register('general_error', 
    (payload) => {
        if(!payload.message) {
            return "Ein unbekannter Fehler ist aufgetreten.";
        }
        return payload.message;
    }, {
    type : 'error',
    duration : 6000,
    theme: "bubble", 
    position: "top-center", 
    keepOnHover: true,
    closeOnSwipe: true,
    action : {
        text : 'Schließen',
        onClick : (e, toastObject) => {
            toastObject.goAway(0);
        }
    },
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.localStorage.getItem('authToken');

new Vue({
 router,
 store,
 vuetify,
 i18n,
 render: h => h(App)
}).$mount('#app')
